/**
 * `documents_edit` → `Documents Edit`.
 *
 * Used for permission keys and role names, both of which arrive as backend snake_case with no
 * label endpoint. Reproduces Retool's own labels, which are the same mechanical transform — see
 * the "Documents Edit / Documents View / Market Edit / Market View" list in its Roles card.
 *
 * A curated label map is deliberately avoided: the permission set is ~90 values served by
 * `GET /v1/internal/partners/:partnerId/roles/permissions/all`, so a map would need maintaining in lockstep with the
 * backend and would render nothing at all for a newly added permission.
 */
export const humanizeSnakeCase = (value: string): string => {
  return value
    .split('_')
    .filter((word) => {
      return word !== ''
    })
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}
